export enum $userRole {
  _id = '_id',
  name = 'name',
  description = 'description',
  translationKey = 'translationKey',
}
